import { z } from 'zod'
import { oc } from '@orpc/contract'
import { boardItemSchema, cellRefSchema } from './boards-shared.contract'

// Where a task came from, for the chart's type tag and filter (PD-1870).
export const PATIENT_CARE_TASK_TYPES = [
  'progress-note',
  'lab-result',
  'fax',
  'letter',
  'manual',
] as const

export const patientCareTaskSchema = z.object({
  // The full board item, so the chart can open the Care Queue drawer on it as-is.
  item: boardItemSchema,
  boardName: z.string(),
  status: z.string().nullable(),
  // Not Done and not in the Completed group.
  isOpen: z.boolean(),
  assignee: cellRefSchema.nullable(),
  dueDate: z.string().nullable(),
  // Null for tasks completed before completion was recorded, and for open tasks.
  completedAt: z.string().nullable(),
  completedBy: cellRefSchema.nullable(),
  checklist: z.object({ done: z.number(), total: z.number() }).nullable(),
  // Notes plus their replies.
  commentCount: z.number(),
  type: z.enum(PATIENT_CARE_TASK_TYPES),
})

// Every Care Queue task for one patient across the caller's org boards — open and
// completed, newest first (PD-1870). Unpaged: a patient has tens of tasks.
export const patientCareTasks = oc
  .route({ method: 'GET', path: '/v2/patients/{patientId}/care-tasks' })
  .input(z.object({ patientId: z.string() }))
  .output(z.object({ tasks: z.array(patientCareTaskSchema) }))
